import React from "react";

import { RoutePermittedRole } from "shared/constants/AppEnums";

import ProfessionalProfile from "./ProfessionalProfile";
import TaxManagement from "./TaxManagement";
import ViewQuiz from "./Quiz/ViewQuiz";
import EditQuiz from "./Quiz/EditQuiz";
import AddQuiz from "./Quiz/AddQuiz";
import SearchContext from "./SearchContext";

const Dashboard = React.lazy(() => import("./Dashboard"));
const Users = React.lazy(() => import("./Users"));
const Students = React.lazy(() => import("./Students"));
const Tutors = React.lazy(() => import("./Tutors"));
const CourseCategories = React.lazy(() => import("./CourseCategories"));
const StaticContent = React.lazy(() => import("./StaticContent"));
const VirtualClassroom = React.lazy(() => import("./VirtualClassroom"));
const AdManagement = React.lazy(() => import("./AdManagement"));
const Books = React.lazy(() => import("./Books"));
const ProductTypes = React.lazy(() => import("./ProductTypes"));
const Coupons = React.lazy(() => import("./Coupons"));
const Blogs = React.lazy(() => import("./Blogs"));
const ClientLogo = React.lazy(() => import("./Client Logo"));
const ScientificEvidence = React.lazy(() => import("./ScientificEvidence"));
const Products = React.lazy(() => import("./Products"));
const OutSourceAuthor = React.lazy(() => import("./OutSourceAuthor"));
const QnA = React.lazy(() => import("./QnA"));
const Testimonials = React.lazy(() => import("./Testimonials"));
const MetaData = React.lazy(() => import("./MetaData"));
const MaterialContent = React.lazy(() => import("./MaterialContent"));
const HomeTestimonial = React.lazy(() => import("./HomeTestimonial"));
const ValueContent = React.lazy(() => import("./ValueContent"));
const VideoContentSection = React.lazy(() => import("./VideoContentSection"));
const VideoContentItem = React.lazy(() => import("./VideoContentItem"));
const ProductTutor = React.lazy(() => import("./ProductTutor"));
const BookCategory = React.lazy(() => import("./BookCategory"));
const EducationalHygienist = React.lazy(() => import("./EducationalHygienist"));
const ProductTraining = React.lazy(() => import("./ProductTraining"));
const Post = React.lazy(() => import("./Post"));
// const ShippingCharges = React.lazy(() => import("./ShippingCharges"));
const ShippingZones = React.lazy(() => import("./ShippingZones"));
const EducationalHygienistMetaData = React.lazy(() => import("./EH_MetaData"));
const EHQnA = React.lazy(() => import("./EH_QnA"));
const EHTestimonials = React.lazy(() => import("./EH_Testimonials"));
const EHMaterial = React.lazy(() => import("./EH_MaterialContent"));
const EHValueContent = React.lazy(() => import("./EH_ValueContent"));
const EHProductTutor = React.lazy(() => import("./EH_ProductTutor"));
const EHCommunity = React.lazy(() => import("./EH_Community"));
const EHVideoContentItem = React.lazy(() => import("./EH_VideoContentItem"));
const EHVideoContentSection = React.lazy(() =>
  import("./EH_VideoContentSection")
);
const LanguageManagement = React.lazy(() => import("./LanguageManagement"));
const ExchangeRate = React.lazy(() => import("./ExchangeRate"));
const WebexAuth = React.lazy(() => import("./WebexAuth"));
const Gallery = React.lazy(() => import("./Gallery"));
const GoogleMap = React.lazy(() => import("./GoogleMap"));
const EVirtualClassroom = React.lazy(() => import("./EH_VirtualClassroom"));
const OrderManagament = React.lazy(() => import("./OrderManagament"));
const RefundManagament = React.lazy(() => import("./RefundManagement"));
const OrderItems = React.lazy(() => import("./OrderItems"));
const ShippingSupplier = React.lazy(() => import("./ShippingSupplier"));
// const ShippingCharges = React.lazy(() => import("./ShippingCharges"));
const Rating = React.lazy(() => import("./Rating"));
const Reports = React.lazy(() => import("./Reports"));
const ContactUs = React.lazy(() => import("./ContactUs"));
const WorkWithUS = React.lazy(() => import("./WorkWithUs"));
const Comments = React.lazy(() => import("./Comments"));
const Tutorship = React.lazy(() => import("./Tutorship"));
const Quiz = React.lazy(() => import("./Quiz"));

export const adminPagesConfigs = [
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/dashboard",
    element: <Dashboard />,
    routeName: "DASHBOARD",
    showRouteIf: true,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/users",
    element: <Users />,
    routeName: "ADMINS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/students",
    element: <Students />,
    routeName: "STUDENTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/search-context",
    element: <SearchContext />,
    routeName: "SEARCH CONTEXT",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/tutors",
    element: <Tutors />,
    routeName: "TUTORS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/course-categories",
    element: <CourseCategories />,
    routeName: "COURSE CATEGORIES",
  },
  // {
  //   permittedRole: RoutePermittedRole.user,
  //   path: "/admin/live-courses",
  //   element: <LiveCourses />,
  //   routeName: "LIVE_COURSES",
  // },

  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/books-category",
    element: <BookCategory />,
    routeName: "BOOKS CATEGORY",
  },

  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/books",
    element: <Books />,
    routeName: "BOOKS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/product-types",
    element: <ProductTypes />,
    routeName: "PRODUCT TYPES",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/ad-management",
    element: <AdManagement />,
    routeName: "AD MANAGEMENT",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/coupons",
    element: <Coupons />,
    routeName: "COUPONS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/blogs",
    element: <Blogs />,
    routeName: "BLOGS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/client-logo",
    element: <ClientLogo />,
    routeName: "CLIENT LOGO",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/professional-profile",
    element: <ProfessionalProfile />,
    routeName: "PROFESSIONAL PROFILE",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/quiz",
    element: <Quiz />,
    routeName: "QUIZ",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/quiz/post",
    element: <AddQuiz />,
    routeName: "QUIZ",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/quiz/:quizId",
    element: <ViewQuiz />,
    routeName: "QUIZVIEW",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/quiz/:quizId/edit",
    element: <EditQuiz />,
    routeName: "EDITQUIZ",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/scientific-evidence",
    element: <ScientificEvidence />,
    routeName: "SCIENTIFIC EVIDENCE",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/products",
    element: <Products />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/outsourceauthor",
    element: <OutSourceAuthor />,
    routeName: "OUTSOURCEAUTHOR",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/products/:productId/Q&A",
    element: <QnA />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/products/:productId/Testimonial",
    element: <Testimonials />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/products/:productId/videos/:videoId/virtual-classroom",
    element: <VirtualClassroom />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/products/:productId",
    element: <MetaData />,
    routeName: "PRODUCTS",
  },

  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/products/:productId/Tools",
    element: <MaterialContent />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/home-page-testimonial",
    element: <HomeTestimonial />,
    routeName: "HOME TESTIMONIAL",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/products/:productId/value-content",
    element: <ValueContent />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/products/:productId/videos",
    element: <VideoContentSection />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/products/:productId/videos/:videoSectionId/video-item",
    element: <VideoContentItem />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/products/:productId/Instructor",
    element: <ProductTutor />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/product-training/:productId",
    element: <MetaData />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/product-training/:productId/Instructor",
    element: <ProductTutor />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/product-training/:productId/Q&A",
    element: <QnA />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/product-training/:productId/Testimonial",
    element: <Testimonials />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/product-training/:productId/Tools",
    element: <MaterialContent />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/product-training/:productId/value-content",
    element: <ValueContent />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/product-training/:productId/Community",
    element: <Post />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/product-training/:productId/videos",
    element: <VideoContentSection />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/static-content",
    element: <StaticContent />,
    routeName: "STATIC CONTENT",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/educational-hygienist",
    element: <EducationalHygienist />,
    routeName: "EDUCATIONAL HYGIENIST",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/educational-hygienist/:productId",
    element: <EducationalHygienistMetaData />,
    routeName: "EDUCATIONAL HYGIENIST",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/educational-hygienist/:productId/Q&A",
    element: <EHQnA />,
    routeName: "EDUCATIONAL HYGIENIST",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/educational-hygienist/:productId/Testimonial",
    element: <EHTestimonials />,
    routeName: "EDUCATIONAL HYGIENIST",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/educational-hygienist/:productId/Tools",
    element: <EHMaterial />,
    routeName: "EDUCATIONAL HYGIENIST",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/educational-hygienist/:productId/value-content",
    element: <EHValueContent />,
    routeName: "EDUCATIONAL HYGIENIST",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/educational-hygienist/:productId/Instructor",
    element: <EHProductTutor />,
    routeName: "EDUCATIONAL HYGIENIST",
  },
  // {
  //   permittedRole: RoutePermittedRole.user,
  //   path: "/admin/educational-hygienist/:productId/Community",
  //   element: <EHCommunity />,
  //   routeName: "EDUCATIONAL HYGIENIST",
  // },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/educational-hygienist/:productId/videos",
    element: <EHVideoContentSection />,
    routeName: "EDUCATIONAL HYGIENIST",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/educational-hygienist/:productId/videos/:videoSectionId/video-item",
    element: <EHVideoContentItem />,
    routeName: "EDUCATIONAL HYGIENIST",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/educational-hygienist/:productId/virtual-classroom",
    element: <EVirtualClassroom />,
    routeName: "EDUCATIONAL HYGIENIST",
  },

  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/product-training",
    element: <ProductTraining />,
    routeName: "PRODUCT TRAINING",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/products/:productId/Community",
    element: <Post />,
    routeName: "PRODUCTS",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/products/:productId/Community/:postId/comments",
    element: <Comments />,
    routeName: "PRODUCTS",
  },
  // {
  //   permittedRole: RoutePermittedRole.user,
  //   path: "/admin/shipping-supplier/:shippingId",
  //   element: <ShippingCharges />,
  //   routeName: "SHIPPING CHARGES",
  // },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/shipping-zones",
    element: <ShippingZones />,
    routeName: "SHIPPING ZONES",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/languages",
    element: <LanguageManagement />,
    routeName: "LANGUAGE",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/exchange-rate",
    element: <ExchangeRate />,
    routeName: "EXCHANGE RATE",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/webex-auth",
    element: <WebexAuth />,
    routeName: "WEBEX AUTH",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/gallery",
    element: <Gallery />,
    routeName: "GALLERY",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/map",
    element: <GoogleMap />,
    routeName: "MAP",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/refundManagement",
    element: <RefundManagament />,
    routeName: "REFUND",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/orders",
    element: <OrderManagament />,
    routeName: "ORDER",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/orders/:orderId",
    element: <OrderItems />,
    routeName: "ORDER",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/reviews",
    element: <Rating />,
    routeName: "RATING",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/reports",
    element: <Reports />,
    routeName: "REPORTS",
  },
  // {
  //   permittedRole: RoutePermittedRole.user,
  //   path: "/admin/shipping-supplier",
  //   element: <ShippingSupplier />,
  //   routeName: "SHIPPING SUPPLIER",
  // },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/shipping-zones",
    element: <ShippingZones />,
    routeName: "SHIPPING ZONES",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/tax-management",
    element: <TaxManagement />,
    routeName: "TAX MANAGEMENT",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/contact-us",
    element: <ContactUs />,
    routeName: "CONTACT US",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/work-with-us",
    element: <WorkWithUS />,
    routeName: "WORK WITH US",
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: "/admin/tutorship",
    element: <Tutorship />,
    routeName: "TUTORSHIP",
  },
  // {
  //   permittedRole: RoutePermittedRole.user,
  //   path: "/admin/community",
  //   element: <Post />,
  //   routeName: "COMMUNITY",
  // },
];
